'use strict';

function getOwnPropertyDescriptors(obj) {
  var descriptors = {};

  Object.getOwnPropertyNames(obj).forEach(function forEachOwnProp(prop) {
    descriptors[prop] = Object.getOwnPropertyDescriptor(obj, prop);
  });

  return descriptors;
}
exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
